import React from 'react'
import { Helmet } from 'react-helmet'
import { useTranslation } from 'react-i18next'
import Content from './components/Content'
import VolumesLayout from '../../components/Layouts/VolumesLayout'

const Volumes = () => {
  const { t } = useTranslation()

  return (
    <>
      <Helmet>
        <meta charSet='utf-8' />
        <title>{t('homepage.title')}</title>
        <link rel='canonical' href='http://moambe.org.ge/volumes' />
        <meta name='moambe, მოამბე' description='moambe, მოამბე' charSet='utf-8' />
      </Helmet>
      <VolumesLayout>
        <Content />
      </VolumesLayout>
    </>
  )
}

export default Volumes
